import { render, staticRenderFns } from "./AddValues.vue?vue&type=template&id=45f828d2&"
import script from "./AddValues.vue?vue&type=script&lang=js&"
export * from "./AddValues.vue?vue&type=script&lang=js&"
import style0 from "./AddValues.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "AddValues.vue"
export default component.exports